module.exports = __webpack_public_path__ + "img/ring_r_s_0_1@3x.6f481f5a.png";